import * as Sentry from '@sentry/react';
import api from 'api';
import { produce } from 'immer';
import store, { State } from 'store';
import postAsync from './postAsync';

import getProjectId from 'utils/url/getProjectId';

export default function createFileset() {
  return postAsync<{ id: string }>({
    post() {
      return api
        .post(`projects/${getProjectId()}/filesets`)
        .json<{ id: string }>()
        .catch((error) => {
          Sentry.captureException(error);
          throw error;
        });
    },
    getAsync() {
      return store.getState().startWorkflow.submit.filesetAsync;
    },
    setAsync(async) {
      store.setState(
        produce((state: State) => {
          state.startWorkflow.submit.filesetAsync = async;
        }),
      );
    },
  });
}
